import { setInnerScroll } from './components/common'
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/brands";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import Cookies from 'js-cookie';

const main = () => {
  const token = document.querySelector('meta[name="csrf-token"]') !== null ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : null;
  window.token = token;

  setInnerScroll()
  /**
   * 全ページ共通アクション
   */
  let windowH = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${windowH}px`)

  // SP用メニュー開閉
  $('#main-header .btn-nav').on('click', () => {
    let headerObj = $('#main-header')
    if (headerObj.hasClass('open')) {
      headerObj.removeClass('open')
    } else {
      headerObj.addClass('open')
    }
  })

  // SP用サブメニュー開閉
  $('#global-nav .submenu > p').on('click', e => {
    let obj = $(e.currentTarget)
    if (obj.hasClass('open')) {
      obj.removeClass('open')
    } else {
      obj.addClass('open')
    }
  })

  const lang = Cookies.get('lang') || 'ja';
  document.querySelector('html').lang = lang;
  if (!location.pathname.match(/^\/(campaign|news)\//)) {
    $('.lang button').on('click', e => {
      const lang = e.currentTarget.dataset.lang;
      Cookies.set('lang', lang, { expires: 7 });
      location.reload();
    });
    
    document.querySelectorAll('.lang').forEach((obj) => {
      obj.querySelector(`button[data-lang="${lang}"]`).classList.add('active');
    })
  }

  const pathname = location.pathname.replace(/\/(restaurant|news)\/.*?$/, "/$1")
  $('#global-nav').find(`a[href="${pathname}"`).closest('li.cat').addClass('active')
}

export default main;